import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Tooltip } from '@ets/design-system';
import { useSelector } from '_common/hooks/redux';
import { selectIsIEnvision } from 'App/redux/appSlice';

const SubmitInIEnvisionButton = () => {
  const intl = useIntl();
  const extra = useSelector((state) => state.app.information.extra);
  const isIEnvision = useSelector(selectIsIEnvision);

  if (!isIEnvision) {
    return null;
  }

  return (
    <Tooltip
      content={intl.formatMessage({ id: 'SUBMIT_IN_IENVISION_MESSAGE' })}
      testId="submit-in-ienvision"
      placement="bottom"
    >
      <Button
        variant="primary"
        size="m"
        onClick={() => {
          if (extra) {
            window.location.href = `${extra.source}`;
          }
        }}
        testId="submit-in-ienvision"
        className="mr-4 ml-8 flex cursor-pointer items-center"
      >
        <FormattedMessage id="SUBMIT_IN_IENVISION" />
      </Button>
    </Tooltip>
  );
};

export default SubmitInIEnvisionButton;
